import { type NotificaUtenteResponseDTO } from '@framework/api-client/api/inquiries-compile/schemas/notificaUtenteResponseDTO.ts';
import { SortByNotifica } from '@framework/api-client/api/inquiries-compile/schemas/sortByNotifica.ts';
import { MarkAsReadButton } from '@framework/common-web/ui/notification/table/MarkAsReadButton.tsx';
import {
  type NotificationRecord,
  notificationColumnsBase,
} from '@framework/common-web/ui/notification/table/notificationColumnsBase.tsx';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Space } from 'antd';
import { type ColumnsType, type ColumnType } from 'antd/es/table';
import { SubmissionDetailButton } from './SubmissionDetailButton.tsx';

const frontNotificationColumnsBase: Record<
  string,
  ColumnType<NotificationRecord>
> = {
  ...notificationColumnsBase,
  numeroIstanza: {
    title: t('notifiche-titolo-colonna.numero-istanza', 'Numero Istanza'),
    dataIndex: 'numeroIstanza',
    key: 'numeroIstanza',
    sorter: true,
    sortDataIndex: SortByNotifica.ID_ISTANZA_RIFERIMENTO,
  },
  action: {
    key: 'action',
    title: (
      <span className="sr-only">
        {t('notifiche-titolo-colonna.azioni', 'Azioni')}
      </span>
    ),
    align: 'right',
    fixed: 'right',
    render: (_: any, record: NotificaUtenteResponseDTO) => (
      <Space size={0}>
        <MarkAsReadButton notification={record} />
        <SubmissionDetailButton submissionId={record.idRichiesta} />
      </Space>
    ),
  },
};

export const frontNotificationColumns: ColumnsType<NotificaUtenteResponseDTO> =
  [
    frontNotificationColumnsBase.letta,
    frontNotificationColumnsBase.oggetto,
    frontNotificationColumnsBase.messaggio,
    frontNotificationColumnsBase.priorita,
    frontNotificationColumnsBase.numeroIstanza,
    frontNotificationColumnsBase.dataNotifica,
    frontNotificationColumnsBase.dataLettura,
    frontNotificationColumnsBase.action,
  ] as ColumnsType<NotificaUtenteResponseDTO>;
